import React from 'react';
import { renderContent } from 'utilities/content/content-utilities';
import { DialogHeading, DialogSection, DialogText } from '../styles/DialogStyles';

function VeryBnplDialogContent() {
  return (
    <>
      <DialogSection>
        <DialogHeading data-testid="bnpl-question-1" size="1" tag="h2" type="heading">
          {renderContent('verypay.dialog.bnpl.questions.question1')}
        </DialogHeading>

        <DialogText data-testid="bnpl-question-1-answer-1" size="1" type="paragraph">
          {renderContent('verypay.dialog.bnpl.questions.answer1.text1')}
        </DialogText>

        <DialogText
          dangerouslySetInnerHTML={{
            __html: renderContent('verypay.dialog.bnpl.questions.answer1.text2'),
          }}
          data-testid="bnpl-question-1-answer-2"
          size="1"
          tag="p"
          type="paragraph"
        />
      </DialogSection>

      <DialogSection>
        <DialogHeading data-testid="bnpl-question-2" size="1" tag="h2" type="heading">
          {renderContent('verypay.dialog.bnpl.questions.question2')}
        </DialogHeading>

        <DialogText data-testid="bnpl-question-2-answer-1" size="1" type="paragraph">
          {renderContent('verypay.dialog.bnpl.questions.answer2')}
        </DialogText>
      </DialogSection>

      <DialogSection>
        <DialogHeading data-testid="bnpl-question-3" size="1" tag="h2" type="heading">
          {renderContent('verypay.dialog.bnpl.questions.question3')}
        </DialogHeading>

        <DialogText data-testid="bnpl-question-3-answer-1" size="1" type="paragraph">
          {renderContent('verypay.dialog.bnpl.questions.answer3.text1')}
        </DialogText>

        <DialogText
          dangerouslySetInnerHTML={{
            __html: renderContent('verypay.dialog.bnpl.questions.answer3.text2'),
          }}
          data-testid="bnpl-question-3-answer-2"
          size="1"
          tag="p"
          type="paragraph"
        />
      </DialogSection>

      <DialogSection>
        <DialogHeading data-testid="bnpl-question-4" tag="h2" size="1" type="heading">
          {renderContent('verypay.dialog.bnpl.questions.question4')}
        </DialogHeading>

        <DialogText data-testid="bnpl-question-4-answer-1" size="1" type="paragraph">
          {renderContent('verypay.dialog.bnpl.questions.answer4')}
        </DialogText>
      </DialogSection>

      <DialogSection>
        <DialogHeading data-testid="bnpl-question-5" size="1" tag="h2" type="heading">
          {renderContent('verypay.dialog.bnpl.questions.question5')}
        </DialogHeading>

        <DialogText data-testid="bnpl-question-5-answer-1" size="1" type="paragraph">
          {renderContent('verypay.dialog.bnpl.questions.answer5.text1')}
        </DialogText>

        <DialogText data-testid="bnpl-question-5-answer-2" size="1" type="paragraph">
          {renderContent('verypay.dialog.bnpl.questions.answer5.text2')}
        </DialogText>

        <DialogText
          dangerouslySetInnerHTML={{
            __html: renderContent('verypay.dialog.bnpl.questions.answer5.text3'),
          }}
          data-testid="bnpl-question-5-3"
          size="1"
          tag="p"
          type="paragraph"
        />
      </DialogSection>

      <DialogSection>
        <DialogHeading data-testid="bnpl-question-6" size="1" tag="h2" type="heading">
          {renderContent('verypay.dialog.bnpl.questions.question6')}
        </DialogHeading>

        <DialogText data-testid="bnpl-question-6-answer-1" size="1" type="paragraph">
          {renderContent('verypay.dialog.bnpl.questions.answer6')}
        </DialogText>
      </DialogSection>

      <DialogSection>
        <DialogHeading data-testid="bnpl-question-7" tag="h2" size="1" type="heading">
          {renderContent('verypay.dialog.bnpl.questions.question7')}
        </DialogHeading>

        <DialogText data-testid="bnpl-question-7-answer-1" size="1" type="paragraph">
          {renderContent('verypay.dialog.bnpl.questions.answer7')}
        </DialogText>
      </DialogSection>
    </>
  );
}

export default VeryBnplDialogContent;
